module.exports = __webpack_public_path__ + "img/vegetable-pumpkin-190x100.f9004a13.jpg";